import React from "react";
import { useStaticQuery, graphql } from "gatsby";

const query = graphql`
  query Timeline {
    allAirtable(
      filter: { table: { eq: "Timeline" } }
      sort: { fields: data___order, order: DESC }
    ) {
      nodes {
        data {
          order
          story
          year
        }
      }
    }
  }
`;

const Timeline = () => {
  const {
    allAirtable: { nodes: timelines },
  } = useStaticQuery(query);

  return (
    <section className={`section timeline`}>
      <div className="section-title">
        <h2>timeline</h2>
        <div className="underline"></div>
      </div>

      <div className={`section-center timeline-center`}>
        {timelines.map((timeline, index) => {
          const { year, story, order } = timeline.data;
          return (
            <article key={index} className="timeline-item">
              <h4>{year}</h4>
              <p>{story}</p>
              <span className="number">{order}</span>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Timeline;
